import { motion } from "framer-motion";
import { ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline";

export default function ServicesSection() {
  return (
    <section id="hizmetler" className="py-20 px-6 lg:px-12">
      <motion.div
        className="max-w-5xl mx-auto text-center space-y-6"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <h2 className="text-4xl font-bold text-gray-900">
          Profesyonel Hizmetlerimiz
        </h2>
        <p className="text-gray-600 text-lg sm:text-xl max-w-4xl mx-auto leading-relaxed">
          Psikolojik danışmanlık hizmetleri; bireyin ihtiyaçları, başvuru nedeni ve
          terapötik sürecin doğası doğrultusunda yapılandırılmaktadır. Amaç,
          yalnızca mevcut zorlukların ele alınması değil; kişinin kendini daha iyi
          anlamasına, duygularını düzenleyebilmesine ve yaşamında daha dengeli bir
          yapı kurabilmesine alan açmaktır.
        </p>
      </motion.div>

      <div className="mt-16">
        <motion.div
          className="bg-white p-8 rounded-2xl shadow-lg flex flex-col lg:flex-row items-start gap-8 max-w-5xl mx-auto"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }}
          transition={{ duration: 0.7 }}
        >
          <div className="flex-shrink-0 flex items-center justify-center w-20 h-20 bg-pink-100 rounded-full">
            <ChatBubbleLeftRightIcon className="h-12 w-12 text-pink-600" />
          </div>

          <div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">
              Bireysel Psikolojik Danışmanlık
            </h3>

            <p className="text-gray-700 mb-6 leading-relaxed">
              Bireysel terapi süreci; kişinin yaşamında zorlayıcı hale gelen
              duygusal, ilişkisel ve psikolojik süreçlerin ele alınmasına yönelik
              yapılandırılmaktadır. Her danışan için süreç, başvuru nedeni ve
              bireysel ihtiyaçlar doğrultusunda şekillendirilmektedir.
            </p>

            <h4 className="text-lg font-medium text-gray-900 mb-3">
              Seans süreci hakkında:
            </h4>

            <ul className="list-disc list-inside space-y-2 text-gray-600 leading-relaxed">
              <li>Seanslar ortalama 50 dakika sürmektedir</li>
              <li>
                Görüşmeler genellikle haftada bir olacak şekilde planlanır;
                gerektiğinde sıklık yeniden düzenlenebilir
              </li>
              <li>
                Süreç, danışanın ihtiyaçlarına göre kısa ya da uzun dönemli olarak
                ilerleyebilir
              </li>
              <li>Seanslar online veya yüz yüze gerçekleştirilmektedir</li>
              <li>
                Tüm görüşmeler etik ilkeler ve mesleki gizlilik çerçevesinde
                yürütülmektedir
              </li>
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
}